/*eslint-disable */

import Vue from "vue";

const url = 'wss://' + process.env.VUE_APP_WEBSOCKET_BASE_URL + '/ws/common/';
let socket = null;
let checkSocketStatus = false;
let checkCommonRoomId = null;
const token = localStorage.getItem('token');

// Interval & Timeout Trackers
let pingInterval = null;
let pongTimeout = null;
let reconnectAttempts = 0;

// Message Queue for handling offline states
let offlineMessageQueue = [];

const emitter = new Vue({
  methods: {
    isOpen() {
      return socket ? socket.readyState : '';
    },

    // Emits JSON objects (flushes immediately if connected, queues if offline)
    emit(message) {
      if (socket && socket.readyState === WebSocket.OPEN) {
        socket.send(JSON.stringify(message));
      } else {
        offlineMessageQueue.push({ type: 'json', data: message });
      }
    },

    // Sends raw data strings (flushes immediately if connected, queues if offline)
    send(message) {
      if (socket && socket.readyState === WebSocket.OPEN) {
        socket.send(message);
      } else {
        offlineMessageQueue.push({ type: 'raw', data: message });
      }
    },

    // Gracefully close connection without auto-reconnecting
    close() {
      checkSocketStatus = true; // Block auto-reconnect logic

      this.clearHeartbeat();
      offlineMessageQueue = []; // Clear pending unsent messages
      reconnectAttempts = 0;

      if (socket && socket.readyState === WebSocket.OPEN) {
        emitter.$emit("close", JSON.stringify({ message: 'Closing Chat', type: 'connectionClosed' }));
        socket.close();
        socket = null;
      }
    },

    // Helper to clean up heartbeat intervals and timeouts
    clearHeartbeat() {
      if (pingInterval) {
        clearInterval(pingInterval);
        pingInterval = null;
      }
      if (pongTimeout) {
        clearTimeout(pongTimeout);
        pongTimeout = null;
      }
    },

    // Flush any messages accumulated while socket was offline
    flushOfflineQueue() {
      while (offlineMessageQueue.length > 0 && socket && socket.readyState === WebSocket.OPEN) {
        const message = offlineMessageQueue.shift();
        if (message.type === 'json') {
          socket.send(JSON.stringify(message.data));
        } else if (message.type === 'raw') {
          socket.send(message.data);
        }
      }
    },

    connect(roomId) {
      const __self = this;
      checkCommonRoomId = roomId;
      checkSocketStatus = false; // Allow reconnection loops to execute

      this.clearHeartbeat();

      socket = new WebSocket(url + roomId + "/?token=" + token);

      socket.onmessage = (response) => {
        let message = JSON.parse(response.data);

        // Handle Heartbeat Pong response from server
        if (message.type === 'pong') {
          if (pongTimeout) {
            clearTimeout(pongTimeout);
            pongTimeout = null;
          }
          return; // Stop execution here for pong messages
        }

        // Event Router Mapping
        const eventMap = {
          userLogin: "userLogin",
          userStatus: "userStatus",
          self_user_stat: "selfUserStatus",
          TypingEventForChat: "TypingEventForSelectedUserNotification",
          newMessageNotification: "newMessageNotifications",
          videoCalling: "videoCallingNotification",
          videoCallAccepted: "videoCallAcceptedNotification",
          videoCallDecline: "videoCallDeclinedNotification",
          videoCallNotReceived: "videoCallDeclinedNotification",
          videoAlertPopupClose: "videoCallAlertPopupClosed"
        };

        const eventName = eventMap[message.type];

        if (eventName) {
          emitter.$emit(eventName, message);
        }

        if (
          message.type === "userLogout"
        ) {
          if (message.videoCallingtypedata) {
            emitter.$emit(
              "autoMissedCallEvent",
              message.videoCallingtypedata
            );
          }

          emitter.$emit("userLogout", message);
        }
      };

      socket.onopen = (event) => {
        reconnectAttempts = 0; // Reset backoff counter on successful link

        emitter.$emit("open", event);
        emitter.$emit("connection", JSON.stringify({ message: 'connection created successfully', type: 'connection' }));

        // Push any queued up clicks/messages sent while offline
        __self.flushOfflineQueue();

        // Heartbeat Monitor: Send ping every 30 seconds
        pingInterval = setInterval(() => {
          if (socket && socket.readyState === WebSocket.OPEN) {
            socket.send(JSON.stringify({ type: 'ping' }));

            // Zombie Connection Trap: Expect 'pong' within 5 seconds
            pongTimeout = setTimeout(() => {
              if (socket) {
                console.warn("WebSocket heartbeat missing (No Pong). Terminating dead connection.");
                socket.close(); // Triggers onclose step below gracefully
              }
            }, 5000);
          }
        }, 30000);
      };

      socket.onclose = (event) => {
        __self.clearHeartbeat();

        // Reconnect with Exponential Backoff if disconnection was unintended
        if (!checkSocketStatus) {
          // Progressively delays: 1s, 2s, 4s, 8s, up to max limit of 10s
          let delay = Math.min(1000 * Math.pow(2, reconnectAttempts), 10000);

          setTimeout(() => {
            reconnectAttempts++;
            __self.connect(checkCommonRoomId);
          }, delay);
        }
      };

      socket.onerror = (err) => {
        emitter.$emit("error", err);
      };
    }
  }
});

export default emitter;